import classNames from "classnames";
import styles from "./fix-dropdown-head.module.scss";
import { useServices } from "@/services-context";
import { FixButton } from "@/elements-react/fix-button";
import { Icon } from "@/elements-react/fix-icon";
import React from "preact/compat";

export interface FixDropdownHeadProps {
  label: string;
  icon?: string;
  active?: boolean;
  type?: string;
  onClick?: () => void;
  iconWidth?: number;
  className?: string;
  hideIcon?: boolean;
  labelClassName?: string;
}

export const FixDropdownHead: React.FC<FixDropdownHeadProps> = ({
  label,
  icon,
  active = false,
  type = "normal",
  children,
  onClick,
  iconWidth,
  className,
  hideIcon,
  labelClassName,
}) => {
  useServices(); // SSR compatibility: hook only

  const iconElement = React.useMemo(() => {
    if (!icon) return null;
    if (icon === "custom") {
      // TODO: Do something with that stub?
      // In React, custom slotting is done via children/props, so this is a stub
      return children;
    }
    return <Icon src={icon} width={iconWidth} />;
  }, [icon, children]);

  const buttonClass = classNames(styles.fixDropdownHeadRoot, {
    [styles.icon]: !!icon,
    [styles.active]: !!active,
    [styles[`type-${type}`]]: true,
  });

  return (
    <FixButton className={classNames(buttonClass, styles.headerButton, className)} labelClassName={classNames(styles.dropDownHeadLabel, labelClassName)} variant="text" size="medium" onClick={onClick} prefix={iconElement}>
      {label}
      {!hideIcon && (
          <div className={styles.icon}>
            <Icon name={"down"} />
          </div>
      )}
    </FixButton>
  );
};

export default FixDropdownHead;
